import React from 'react';
import PropTypes from 'prop-types';

import localization from '../../shared/strings';
import RadioItem from '../RadioItem';

const MODES = ['crop', 'resize'];

export default function AssetsCopyTransformationModeToggle({
  mode,
  onChange,
  disabled,
}) {
  const L = localization.COPY_ASSETS_DIALOG;
  const labels = {
    crop: L.transformationModeCrop,
    resize: L.transformationModeResize,
  };

  return React.createElement(
    'div',
    { className: 'assetsCopyDialog__modeToggle' },
    MODES.map((value) => (
      <RadioItem
        key={value}
        value={value}
        label={labels[value]}
        checkedValue={mode}
        disabled={disabled}
        onChange={onChange}
      />
    )),
  );
}

AssetsCopyTransformationModeToggle.propTypes = {
  mode: PropTypes.oneOf(MODES).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AssetsCopyTransformationModeToggle.defaultProps = {
  disabled: false,
};
